<template>
    <div
        v-if="visible"
        class="w-full px-[10px]"
        :class="opened ? 'block' : 'hidden xl:block'"
    >
        <div
            class="w-full rounded-[6.75px] bg-[#0B1220] p-4 text-gray-200 shadow-sm"
        >
            <div class="flex items-center justify-between gap-2">
                <span class="truncate text-[11px] font-medium text-white">
                    {{ title }}
                </span>

                <span
                    v-if="secondaryLabel !== null && secondaryLabel !== ''"
                    class="shrink-0 text-[11px] font-medium text-gray-300"
                >
                    {{ secondaryLabel }}
                </span>
            </div>

            <div
                class="mt-2 h-3 w-full rounded-full"
                :class="progressTrackClass"
            >
                <div
                    class="h-3 rounded-full transition-all duration-200"
                    :class="progressBarClass"
                    :style="progressStyle"
                ></div>
            </div>

            <button
                type="button"
                class="mt-3 w-full cursor-pointer rounded-[6.75px] bg-[#088BEA] py-2 text-sm font-semibold text-white hover:bg-[#0A7ED3]"
                @click="handleAction"
            >
                {{ actionLabel }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, type CSSProperties } from "vue";

interface IProps {
    opened?: boolean;
    visible?: boolean;
    title: string;
    secondaryLabel?: string | null;
    progress?: number;
    progressTrackClass?: string;
    progressBarClass?: string;
    actionLabel: string;
}

const props = withDefaults(defineProps<IProps>(), {
    opened: false,
    visible: true,
    secondaryLabel: null,
    progress: 0,
    progressTrackClass: "bg-[#2A3344]",
    progressBarClass: "bg-[#04C951]",
});

const emit = defineEmits<{
    action: [];
}>();

const normalizedProgress = computed<number>(() => {
    if (Number.isFinite(props.progress) === false) {
        return 0;
    }

    return Math.max(0, Math.min(100, props.progress));
});

const progressStyle = computed<CSSProperties>(() => ({
    width:
        normalizedProgress.value > 0 ? `${normalizedProgress.value}%` : "2px",
}));

const handleAction = () => {
    emit("action");
};
</script>
